export default "__VITE_ASSET__DSVp9VQe__"